<div class="date-range white-box main-black p-4 border-radius-bottom">
	<div class="border-bottom d-flex justify-content-between p-3">
		<h2>{{ 'admin.brm_devices_simulation' | translate }}</h2>
		<button class="btn btn-primary mb-3" type="button" (click)="clearAllEvents()">{{"g.clear_all" | translate}}</button>
	</div>

	<details open *ngFor="let group of groups; let groupIndex = index" class="mb-3">
		<summary>{{group.name}}</summary>

		<div class="device-box" *ngFor="let device of group.devices; let i = index">
			<div class="d-flex justify-content-between align-items-center">
				<!-- header left side -->
				<div class="d-flex align-items-center">
					<strong>{{device.serialNumber}}:</strong>
					<div class="ml-5">
						<input type="checkbox" class="form-check-input" [(ngModel)]="device.battery_connected">
						<span class="text-muted">{{"qv.battery_connected" | translate}}</span>
					</div>
				</div>

				<!-- header right side -->
				<div>
					<button class="btn btn-primary mb-3" type="button" (click)="clearDeviceEvents(device.macAddress, groupIndex)">{{"devices.clear_device_events" | translate}}</button>
					<button class="btn btn-secondary mb-3 ml-3" type="button" (click)="showAddEventsPopup(device.macAddress, groupIndex)">{{"g.insert_event" | translate}}</button>
				</div>
			</div>

			<!-- device events -->
			<div class="device-events" *ngIf="device.events && device.events.length > 0; else noData">
				<table class="table table-striped">
					<thead>
						<tr>
							<th scope="col">{{ 'event.sequence_id' | translate}}</th>
							<th scope="col">{{ 'events.event_type' | translate }}</th>
							<th scope="col">{{ 'events.event_duration' | translate }} ({{"g.seconds" | translate}})</th>
							<th scope="col">{{ 'events.end_soc' | translate }}</th>
							<th scope="col">{{ 'nav.actions' | translate }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let event of device.events; let i = index">
							<td>{{event.sequence_id || i + 1}}</td>
							<td>{{(event.event_type ? ('events.event_type_' + event.event_type) : 'events.event_type_off') | translate }}</td>
							<td>{{event.calc_duration}}</td>
							<td>{{event.end_soc}}</td>
							<td>
								<button class="btn btn-danger" type="button" (click)="deleteEvent(device.macAddress, i, groupIndex)">{{"g.delete" | translate}}</button>
								<button class="btn btn-secondary ml-2" type="button" (click)="openEditEventPopup(device.macAddress, i, groupIndex)">{{"g.edit" | translate}}</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<hr *ngIf="i < group.devices.length - 1" class="my-4" />
		</div>
	</details>

	<div class="d-flex justify-content-end">
		<button class="btn btn-primary mb-3" type="button" (click)="submit()">{{"g.submit" | translate}}</button>
	</div>
</div>

<app-modal
	[hasCloseButton]="false"
	[hasConfirmButton]="false"
	#addEventsPopup title="{{'events.insert' | translate}}"
	size="lg"
>
	<div class="p-4" *ngIf="insertEventsError">
		<div class="alert alert-danger d-flex align-items-center" role="alert">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			<strong>{{ insertEventsError }}</strong>
		</div>
	</div>

	<div class="p-4">
		<span>{{"events.event_type" | translate}}</span>
		<ng-select
			[(ngModel)]="newEvent.event_type"
			[items]="eventTypes"
			name="tags_filter"
			bindValue="value"
			bindLabel="label"
			[clearable]="false"
		></ng-select>
		<span class="mt-2">{{"events.event_duration" | translate}} ({{"g.seconds" | translate}})</span>
		<input
			type="number"
			class="form-control"
			[(ngModel)]="newEvent.calc_duration"
			placeholder="{{'events.event_duration' | translate}}"
			name="event_duration"
			min="0"
			max="86400"
		/>
		<span class="mt-2">{{"events.end_soc" | translate}}</span>
		<input
			type="number"
			class="form-control"
			[(ngModel)]="newEvent.end_soc"
			placeholder="{{'events.event_duration' | translate}}"
			name="event_duration"
			min="0"
			max="100"
		/>
	</div>

	<!-- buttons section -->
	<div class="d-flex justify-content-end p-4">
		<button class="btn btn-secondary mr-2" type="button" (click)="addEventsPopup.hide()">{{"g.cancel" | translate}}</button>
		<button class="btn btn-primary" type="button" (click)="addEvent(false)">{{"g.insert" | translate}}</button>
		<button class="btn btn-primary ml-2" type="button" (click)="addEvent(true)">{{"g.insert_and_continue" | translate}}</button>
	</div>
</app-modal>

<!-- edit event popup -->
<app-modal
	[hasCloseButton]="false"
	[hasConfirmButton]="false"
	#editEventPopup title="{{'events.edit' | translate}}"
	size="lg"
>
	<div class="p-4" *ngIf="editEventError">
		<div class="alert alert-danger d-flex align-items-center" role="alert">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			<strong>{{ editEventError }}</strong>
		</div>
	</div>

	<div class="p-4">
		<span>{{"events.event_type" | translate}}</span>
		<ng-select
			[(ngModel)]="editEvent.event.event_type"
			[items]="eventTypes"
			name="tags_filter"
			bindValue="value"
			bindLabel="label"
			[clearable]="false"
		></ng-select>
		<span class="mt-2">{{"events.event_duration" | translate}} ({{"g.seconds" | translate}})</span>
		<input
			type="number"
			class="form-control"
			[(ngModel)]="editEvent.event.calc_duration"
			placeholder="{{'events.event_duration' | translate}}"
			name="event_duration"
			min="0"
			max="86400"
		/>
		<span class="mt-2">{{"events.end_soc" | translate}}</span>
		<input
			type="number"
			class="form-control"
			[(ngModel)]="editEvent.event.end_soc"
			placeholder="{{'events.end_soc' | translate}}"
			name="end_soc"
			min="0"
			max="100"
		/>
	</div>
	<!-- buttons section -->
	<div class="d-flex justify-content-end p-4">
		<button class="btn btn-secondary mr-2" type="button" (click)="editEventPopup.hide()">{{"g.cancel" | translate}}</button>
		<button class="btn btn-primary" type="button" (click)="editDeviceEvent()">{{"g.save" | translate}}</button>
	</div>
</app-modal>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
